<template src="../templates/normal_fcont_159.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';

import { Carousel,Slide } from 'uiv'
import { mapState } from "vuex";

export default {
  name: 'app',
  data() {
    return {
      articleId: '159',
      eventActionTop: 'insta_top',
      eventActionBottom: 'insta_bottom',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  computed: {
    ...mapState(["os"]),
    isPc: function () {
      return this.os == "ws" || this.os == "mi";
    },
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    ReleaseDateForArticle
  },
  methods: {
    clickLinkTop: function () {
      window.open("https://www.instagram.com/epsongallery/");
    },
    clickLinkBottom: function () {
      window.open("https://www.instagram.com/epsongallery/");
    },
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['159-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['159-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
.instagram_link_area1 {
  margin-top: 20px;
}

.instagram_link_area2 {
  margin-top: 40px; 
  font-size: 18px; 
  line-height: 1.33; 
  text-align: center;
}

.instagram_button {
  margin-top: 10px;
  max-width: 100%;
  white-space: normal;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.instagram_logo {
  width: 48px; 
  height: 48px; 
  margin: 14px 24px 14px 24px; 
}

.instagram_button span {
  margin-right: 24px;
}

.instagram_qr {
  width: 100px; 
  height: 100px; 
  margin: 14px 24px 14px 0px;
}

.present_caption {
  margin-left: 15px;
}

.present_title {
  line-height: 1.5;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
  .instagram_link_area2 {
    margin-top: 20px;
    font-size: 14px; 
  }

  .instagram_logo {
    width: 40px; 
    height: 40px; 
    margin: 10px 20px 10px 10px; 
  }
  
  .instagram_button span {
    font-size: 14px;
    margin-right: 5px;
  }

  .present_caption {
    margin-bottom: 40px;
  }
}
</style>

